import SendIcon from 'assets/ver2/icons/header/remittance-icon.svg';
import EventItem from 'components/Dashboard/components/EventsSidebar/EventItem';
import ExchangeRateSectionMobile from 'components/Dashboard/components/ExchangeRateSection/mobile/ver2';
import ExchangeRateSection from 'components/Dashboard/components/ExchangeRateSection/ver2';
import Transactions from 'components/Transactions';
import { fetchTransactionsFiltered } from 'components/Transactions/func';
import TransactionsMobile from 'components/Transactions/mobile';
import ButtonCommon from 'components/common/ButtonCommon';
import CollapsibleSideMenu from 'components/common/CollapsibleSideMenu';
import OuterBodyContent from 'components/common/CollapsibleSideMenu/OuterBodyContent';
import OuterPathContent, {
  DateTimeSection,
  SubTitle,
  Title,
  TitleMobile,
} from 'components/common/CollapsibleSideMenu/OuterPathContent';
import HorizontalSwiper from 'components/common/HorizontalSwiper/ver2';
import MobileTabMenu from 'components/common/MobileTabMenu';
import NavbarFooter from 'components/common/NavbarFooter/ver3';
import SizeBox from 'components/common/SizeBox';
import { fetchCountries } from 'components/common/func';
import {
  DESKTOP_MIN_WIDTH,
  SCREEN_ID_REMITTANCE_HOME,
  TRANSACTION_ADD_PREFIX,
  TRANSACTION_TABLE_SORT_ORDER_INITIAL,
} from 'constants';
import useReferral from 'features/referral/hooks/useReferral';
import { datePicker } from 'helpers';
import Cookies from 'helpers/cookies';
import { MAKE_PAYMENT_KEY } from 'hooks/form-add-transaction/useAddTransaction';
import useAuth from 'hooks/useAuth';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useEvent from 'hooks/useEvent';
import useExchangeRates from 'hooks/useExchangeRates';
import useLang from 'hooks/useLang';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

const SCREEN_ID = SCREEN_ID_REMITTANCE_HOME;

const DashboardPage = () => {
  const { t, locate } = useLang();
  const { state } = useStore();
  const { exchangeRates, eventsOnSidebar } = state || {};
  const { token } = useAuth();
  const navigate = useNavigate();
  const { isDesktop } = useDetectDevice();
  const { remittanceRatesData } = useExchangeRates();
  const { isReferee1st } = useReferral();
  const { isHHMTTheme } = useTheme();

  const [transactions, setTransactions] = useState(null);
  const [countries, setCountries] = useState(null);
  const [sortOrder, setSortOrder] = useState(
    TRANSACTION_TABLE_SORT_ORDER_INITIAL
  );

  const isExchangeRatesEmpty = !Boolean(exchangeRates);

  useEffect(() => {
    fetchTransactionsFiltered({ token, setTransactions });
    fetchCountries((data) => {
      setCountries(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const { isShowEvent, showEventModal } = useEvent({
    screenId: SCREEN_ID,
    params: [],
    modalStyles: {
      width: 436,
      borderRadius: 20,
    },
    modalOptions: {
      action1Name: 'close',
      action2Name: isReferee1st ? 'send-now' : 'refer-now',
    },
    isForceToCheckEventEligible: true,
  });
  useEffect(() => {
    if (!isShowEvent) return;
    showEventModal();
  }, [isShowEvent]);

  if (isEmpty(countries) && isDesktop)
    return (
      <CollapsibleSideMenu>
        <OuterBodyContent></OuterBodyContent>
      </CollapsibleSideMenu>
    );
  if (isEmpty(countries) && !isDesktop)
    return (
      <OuterBodyContent>
        <NavbarFooter />
      </OuterBodyContent>
    );
  if (!isDesktop) {
    return (
      <OuterBodyContent>
        <OuterPathContent>
          <MobileTabMenu />
          <Title>{t('dashboard_favourite_receiving_countries')}</Title>
          <DateTimeSection>
            {datePicker.getFullTimeStringTranslate(locate)}
          </DateTimeSection>
          <ExchangeRateSectionMobile
            remittanceRatesData={remittanceRatesData}
            countries={countries}
          />
        </OuterPathContent>
        {isHHMTTheme && (
          <HorizontalSwiper
            data={eventsOnSidebar}
            styles={{ marginTop: '16px', zIndex: 0 }}
            SlideItemComponent={EventItem}
          />
        )}
        <SizeBox height={16} />
        <TitleMobile>{t('dashboard_tab_recent_transaction')}</TitleMobile>
        <TransactionsMobile
          transactions={transactions}
          setTransactions={setTransactions}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
        />
        <NavbarFooter />
      </OuterBodyContent>
    );
  }
  return (
    <CollapsibleSideMenu>
      <OuterBodyContent>
        {!isExchangeRatesEmpty && (
          <>
            <OuterPathContent>
              <Title>{t('dashboard_favourite_receiving_countries')}</Title>
              <SizeBox height={5} />
              <DateTimeSection>
                {datePicker.getFullTimeStringTranslate(locate)}
                <ButtonCommon
                  value={t('button_send_money')}
                  color="var(--c-primary)"
                  background="var(--bg-primary)"
                  isFill={true}
                  styles={{
                    paddingInline: 0,
                  }}
                  buttonIconStyles={{
                    float: 'right',
                    height: '50px',
                    paddingInline: '30px',
                    gap: '4px',
                  }}
                  iconSrc={SendIcon}
                  onClick={() => {
                    Cookies.remove(MAKE_PAYMENT_KEY);
                    navigate(`${TRANSACTION_ADD_PREFIX}`);
                  }}
                />
              </DateTimeSection>
              <ExchangeRateSection
                remittanceRatesData={remittanceRatesData}
                countries={countries}
              />
            </OuterPathContent>
            <SizeBox height={20} />
          </>
        )}
        <OuterPathContent>
          <SubTitle>{t('dashboard_tab_recent_transaction')}</SubTitle>
          <Transactions
            transactions={transactions}
            setTransactions={setTransactions}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
          />
        </OuterPathContent>
      </OuterBodyContent>
    </CollapsibleSideMenu>
  );
};

export const DashboardStyled = styled.div`
  margin: 70px 0px 0px 0px;
  box-shadow: none;
  height: calc(100dvh - 70px);
  padding: 16px;
  position: relative;
  background-color: #fcfcfc;
  border-radius: 12px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    height: fit-content;
    margin: 96px 50px 47px 0;
    padding: 0px;
    background-color: transparent;
  }
`;

export const ExchangeRatePath = styled.div`
  border-radius: 0 0 20px 20px;
  border: none;
  padding: 16px;
  background: #fff;
  margin-top: -16px;
  margin-inline: -16px;
  box-shadow: 0px 4px 15px 0px #0000001a;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    border-radius: 12px;
    border: 1px solid var(--ds-c-blue-remox-light);
    padding: 24px 40px;
    background: #fff;
    margin-top: unset;
    margin-inline: unset;
    box-shadow: none;
  }
`;
export const TransactionsPath = styled.div`
  border-radius: 12px;
  border: 1px solid var(--ds-c-blue-remox-light);
  padding: 24px 40px;
  background: #fff;
`;

export default DashboardPage;
